export const TOGGLE_MENU = 'TOGGLE_MENU';

export const toggleMenu = () => {
  return {
    type: TOGGLE_MENU,
  };
};